// Shared CSS for KnowMeno-generated PDFs (Symptom Intelligence Report, Annual Wellness
// Summary). Single source of truth so the two PDFs stay visually consistent
// and brand colors only live in one place.
//
// Consumed by generateReportPDF in KnowMenoApp.tsx and (soon) the AWS PDF
// generator. Injected verbatim inside a <style> tag in the popup document.

export const PDF_STYLES = `
  :root {
    --pd-plum: #4B1F4F;
    --pd-soft-plum: #856589;
    --pd-coral: #FF5C7A;
    --pd-pink: #FFC1CD;
    --pd-ivory: #FAF7F5;
    --pd-light-pink: #FFE4EA;
    --pd-warm-taupe: #E8D5DA;
    --pd-muted-purple: #6E4B71;
  }
  @page{margin:0.6in;}
  body{font-family:-apple-system,system-ui,sans-serif;color:var(--pd-plum);line-height:1.55;max-width:740px;margin:0 auto;padding:24px;}
  h1{font-size:22px;margin:0 0 4px;font-weight:600;}
  h2{font-size:14px;font-weight:600;color:var(--pd-soft-plum);text-transform:uppercase;letter-spacing:0.06em;margin:28px 0 10px;border-bottom:1px solid var(--pd-warm-taupe);padding-bottom:6px;}
  h3{font-size:12px;font-weight:600;color:var(--pd-plum);text-transform:uppercase;letter-spacing:0.06em;margin:16px 0 8px;}
  .meta{color:var(--pd-soft-plum);font-size:12px;margin-bottom:18px;}
  .hdr{background:linear-gradient(135deg,var(--pd-plum),var(--pd-coral));color:#fff;padding:20px;border-radius:12px;margin-bottom:24px;}
  .hdr h1{color:#fff;}
  .hdr .sub{opacity:0.8;font-size:12px;margin-top:6px;}
  .summary{background:var(--pd-ivory);padding:16px 18px;border-radius:10px;font-size:13px;line-height:1.7;margin-bottom:18px;}
  table{width:100%;border-collapse:collapse;font-size:13px;margin-bottom:12px;}
  th,td{text-align:left;padding:9px 8px;border-bottom:1px solid var(--pd-ivory);}
  th{color:var(--pd-soft-plum);font-weight:500;font-size:11px;text-transform:uppercase;letter-spacing:0.04em;}
  .flag{display:inline-block;padding:3px 9px;border-radius:12px;font-size:11px;font-weight:500;}
  .flag-high{background:var(--pd-light-pink);color:#A32D2D;}
  .flag-med{background:#FAEEDA;color:var(--pd-plum);}
  .flag-good{background:var(--pd-light-pink);color:var(--pd-plum);}
  .flag-neu{background:var(--pd-ivory);color:#6E4B71;}
  .kpi{background:var(--pd-ivory);border-radius:10px;padding:14px 16px;margin-bottom:14px;}
  .kpi-big{font-size:28px;font-weight:600;line-height:1;margin-bottom:4px;}
  .note{background:var(--pd-ivory);padding:12px 16px;border-radius:10px;margin-top:12px;font-size:12px;line-height:1.65;}
  .note-rx{background:var(--pd-light-pink);border-left:3px solid var(--pd-pink);}
  .note-cycle{background:var(--pd-light-pink);border-left:3px solid var(--pd-coral);}
  .cycle-row{margin-bottom:8px;}
  .cycle-bar{position:relative;height:16px;background:var(--pd-ivory);border-radius:3px;overflow:hidden;}
  .cycle-band{position:absolute;top:0;bottom:0;background:rgba(29,158,117,0.12);border-left:1px dashed rgba(29,158,117,0.5);border-right:1px dashed rgba(29,158,117,0.5);}
  .footer{margin-top:40px;padding-top:16px;border-top:1px solid var(--pd-warm-taupe);font-size:11px;color:var(--pd-muted-purple);}
  .noprint{margin:20px 0;padding:12px 16px;background:var(--pd-light-pink);border-radius:10px;font-size:13px;color:var(--pd-plum);}
  @media print{.noprint{display:none;}body{padding:0;}}
  .btn{display:inline-block;padding:10px 20px;background:var(--pd-pink);color:#fff;border:none;border-radius:8px;font-size:14px;cursor:pointer;font-weight:500;}
  h1, h2, h3 { page-break-after: avoid; }
  .section, table, .flag-card, .summary-card { page-break-inside: avoid; }
  img, svg { page-break-inside: avoid; max-width: 100%; }
  .empty-state-notice { color: var(--pd-soft-plum); font-style: italic; font-size: 14px; padding: 12px 0; }
`;
